import React from 'react';

import baseStyles from '../../css/citations.module.css';
import { Author } from '../../models/aggregatorData';
import mStyles from './manuscriptInfo.module.css';


type Props = {
  authors: Author[];
  manuscriptTitle: string;
}

const UTF2000 = " "

const manuscriptInfo = (props: Props) => {
  const styles = {...baseStyles, ...mStyles};

  const authorNames = props.authors.map((author) => {
    return author.fullName;
  })

  return (
    <div className={styles.mInfoPanel}>
      <div className={styles.manuscriptInfoName}>{props.manuscriptTitle}
      </div>
      <div className={styles.manuscriptAuthorsList}>
        <div>
          {
            authorNames.join(","+UTF2000)
          }
        </div>
      </div>
    </div>

  )
}

export default manuscriptInfo;
